import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const prepareSeoToClient = (res: IPropertyDetailsResponse) => {
    const seo = {
      description_en: "",
      keywords_en: [],
      short_description_en: "",
      title_en: "",
  
      description_es: res?.description ?? "",
      keywords_es: [],
      short_description_es: "",
      title_es: ""
    };
  
    if (res?.info.length <= 0) return seo;
  
    const seoSpanish = res?.info.find(item => item.language_id === 1);
    const seoEnglish = res?.info.find(item => item.language_id === 2);
    if (seoSpanish && seoEnglish) {
      seo.description_es = seoSpanish.description ?? res?.description ?? "";
      seo.keywords_es = (seoSpanish.keywords?.split(",") ?? []) as any;
      seo.short_description_es = seoSpanish.short_description;
      seo.title_es = seoSpanish.title;
  
      seo.description_en = seoEnglish.description;
      seo.keywords_en = (seoEnglish.keywords?.split(",") ?? []) as any;
      (seo.short_description_en = seoEnglish.short_description),
        (seo.title_en = seoEnglish.title);
    }
    return seo;
  };

  export default prepareSeoToClient